module.exports = __webpack_public_path__ + "img/verified-secured.de48cad9.jpg";